// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3LlJt","actions":"GroupTable_actions__3kSrz","deleteModalFooter":"GroupTable_deleteModalFooter__vHxMU"};